class FlixVariantPicker extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('[data-variant-json]');
    if (!dataEl) return;
    try { this._variants = JSON.parse(dataEl.textContent); } catch (e) { this._variants = []; }
    this._groups = Array.from(this.querySelectorAll('[data-option-index]'));
    // Every button in here that puts this product in the cart. Add to cart
    // and Buy now are both triggers, and both have to follow the selection:
    // a trigger left on the variant the page rendered with sells the wrong
    // thing at the wrong price.
    this._triggers = Array.from(this.querySelectorAll('[data-flix-add-to-cart],[data-flix-buy-now]'));
    this._priceEl = this.querySelector('[data-flix-variant-price]');
    this._compareEl = this.querySelector('[data-flix-variant-compare]');
    this._freeText = this.dataset.i18nFree || 'Free';

    this._groups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((b) => { b.dataset.selected = 'false'; });
          btn.dataset.selected = 'true';
          this._paintGroup(group);
          this._applySelection();
        });
      });
      this._paintGroup(group);
    });
    this._applySelection();
  }

  // The selected/unselected pill styling is set inline server-side for the
  // initial render; clicking only flips the data-selected attribute, so the
  // visual state needs repainting here too or the toggle never visibly moves.
  _paintGroup(group) {
    group.querySelectorAll('[data-option-value]').forEach((b) => {
      const active = b.dataset.selected === 'true';
      b.style.background = active ? 'var(--accent)' : 'transparent';
      b.style.color = active ? '#160d05' : 'var(--dim)';
    });
  }

  _selectedOptions() {
    return this._groups.map((group) => {
      const sel = group.querySelector('[data-option-value][data-selected="true"]') || group.querySelector('[data-option-value]');
      return sel ? sel.dataset.optionValue : null;
    });
  }

  _findVariant() {
    const sel = this._selectedOptions();
    return this._variants.find((v) => v.options.every((opt, i) => opt === sel[i])) || this._variants[0];
  }

  _applySelection() {
    const variant = this._findVariant();
    if (!variant) return;
    this._current = variant;
    this._triggers.forEach((btn) => {
      btn.dataset.variantId = variant.id;
      // Recorded as data as well as applied, so the cart handler can put
      // the button back in the RIGHT state after a request — it disables
      // the button while adding, and re-enabling it unconditionally would
      // unlock a sold-out variant chosen in the meantime.
      btn.dataset.unavailable = variant.available ? 'false' : 'true';
      // Left alone while a request is in flight: the cart handler owns the
      // disabled state until it finishes, then restores it from the data.
      if (btn.dataset.flixLoading !== 'true') btn.disabled = !variant.available;
      btn.style.opacity = variant.available ? '1' : '.5';
      btn.style.cursor = variant.available ? 'pointer' : 'not-allowed';
    });
    if (this._priceEl) this._priceEl.textContent = variant.price_is_free ? this._freeText : variant.price;
    if (this._compareEl) this._compareEl.textContent = variant.on_sale ? variant.compare_at_price : '';
    this.dispatchEvent(new CustomEvent('flix:variant:change', { bubbles: true, detail: { variant } }));
  }

  get currentVariant() {
    return this._current;
  }
}
customElements.define('flix-variant-picker', FlixVariantPicker);
